import { AlternativeDetailsDialogViewModel } from '@Alternatives/Alternatives/Components/AlternativeDetailsDialog';
import AlternativeDetailsDialog from "@Alternatives/Alternatives/Components/AlternativeDetailsDialog.vue";
import { isNullOrWhitespace, numCompare } from "@common/Common";
import { CriterionDetailsDialogViewModel } from '@Criteria/Hierarchies/Components/CriterionDetailsDialog';
import CriterionDetailsDialog from "@Criteria/Hierarchies/Components/CriterionDetailsDialog.vue";
import PanelistSurveyVoteEditorDr from "@Evaluation/AlternativesSurveys/Components/PanelistSurveyVoteEditorDr.vue";
import PanelistSurveyVoteEditorPc from "@Evaluation/AlternativesSurveys/Components/PanelistSurveyVoteEditorPc.vue";
import { SavePanelistVotesCommandV1 } from "@Evaluation/AlternativesSurveys/Domain/commands-core";
import ScoringCommands from '@Evaluation/AlternativesSurveys/Domain/commands-vue-component';
import ScoringQueries from '@Evaluation/AlternativesSurveys/Domain/queries-vue-component';
import { PanelistSurveyCriterionConsistencyAnalysisReadModel, PanelistSurveyCriterionPageReadModel, PanelistSurveyQuestionReadModel } from '@Evaluation/AlternativesSurveys/Domain/readmodels';
import { IEvaluationCommand } from '@Evaluation/cqrs';
import { DiscreteScaleLevelReadModel } from "@Scales/Domain/readmodels";
import Component, { mixins } from 'vue-class-component';
import { Route } from 'vue-router';


@Component({
    components: {
        PanelistSurveyVoteEditorDr, PanelistSurveyVoteEditorPc, AlternativeDetailsDialog, CriterionDetailsDialog
    },
    watch: {
        IsSaved: 'onIsSavedChanged'
    }
})
export default class PanelistSurveyCriterionPage extends mixins(ScoringCommands, ScoringQueries) {

    get workspaceId() { return Number.parseInt(this.$route.params.workspaceId); }
    get surveyId(): number { return Number.parseInt(this.$route.params.surveyId); }
    get projectUserId(): number { return Number.parseInt(this.$route.params.projectUserId); }
    get criterionId(): number { return Number.parseInt(this.$route.params.criterionId); }

    initialized: boolean = false;
    IsSaved: boolean = true;
    AutoSaveHandle: NodeJS.Timeout = null;
    SearchPhrase: string = null;
    QuestionsFilter: string = null;
    alternativeDetailsDialog = new AlternativeDetailsDialogViewModel();
    criterionDetailsDialog: CriterionDetailsDialogViewModel = new CriterionDetailsDialogViewModel();

    rm: PanelistSurveyCriterionPageReadModel = null;
    get alternativeLabel(): string { return this.rm.AlternativeLabel; }
    get alternativesLabel(): string { return this.rm.AlternativesLabel; }
    get consistencyAnalysis(): PanelistSurveyCriterionConsistencyAnalysisReadModel { return this.rm.ConsistencyAnalysis; }
    get questionsCount(): number { return this.rm.QuestionsCount; }
    get directRates(): PanelistSurveyQuestionReadModel[] { return this.rm.Questions.filter(a => a.IsPairwise === false); }
    get pairwiseComparisons(): PanelistSurveyQuestionReadModel[] { return this.rm.Questions.filter(a => a.IsPairwise === true); }
    get isPairwise(): boolean { return this.rm.ScaleLevels == null; }
    get scaleLevels(): DiscreteScaleLevelReadModel[] { return this.rm.ScaleLevels.sort((a, b) => numCompare(a.Value, b.Value)); }
    get nextCriterionId(): number { return this.rm.NextCriterionId; }
    get prevCriterionId(): number { return this.rm.PrevCriterionId; }
    get progress(): number { return Math.round(100 * this.AnsweredQuestionsCount / this.questionsCount); }
    get criterionName(): string { return this.rm.CriterionName; }

    get DirectRatesView()
    {
        let view = [...this.directRates];

        if (!isNullOrWhitespace(this.SearchPhrase))
        {
            const phrase = this.SearchPhrase.toLowerCase();
            view = view.filter(q => q.AlternativeName.toLowerCase().indexOf(phrase) >= 0);
        }

        if (this.QuestionsFilter === "Answered")
        {
            view = view.filter(a => a.Value != null);
        }
        else if (this.QuestionsFilter === "Not answered")
        {
            view = view.filter(a => a.Value == null);
        }
        else if (this.QuestionsFilter === "Commented")
        {
            view = view.filter(a => !isNullOrWhitespace(a.Comment));
        }
        else if (this.QuestionsFilter === "Not commented")
        {
            view = view.filter(a => isNullOrWhitespace(a.Comment));
        }

        return view;
    }
    get PairwiseComparisonsView()
    {
        let view = [...this.pairwiseComparisons];

        if (!isNullOrWhitespace(this.SearchPhrase))
        {
            const phrase = this.SearchPhrase.toLowerCase();
            view = view.filter(q => q.FirstAlternativeName.toLowerCase().indexOf(phrase) >= 0 || q.SecondAlternativeName.toLowerCase().indexOf(phrase) >= 0);
        }

        if (this.QuestionsFilter === "Answered")
        {
            view = view.filter(a => a.Value != null);
        }
        else if (this.QuestionsFilter === "Not answered")
        {
            view = view.filter(a => a.Value == null);
        }
        else if (this.QuestionsFilter === "Commented")
        {
            view = view.filter(a => !isNullOrWhitespace(a.Comment));
        }
        else if (this.QuestionsFilter === "Not commented")
        {
            view = view.filter(a => isNullOrWhitespace(a.Comment));
        }

        return view;
    }
    get AnsweredQuestionsCount(): number { return this.rm.Questions.filter(a => a.Value != null).length; }
    get NotAnsweredQuestionsCount(): number { return this.questionsCount - this.AnsweredQuestionsCount; }
    get CommentedQuestionsCount(): number { return this.rm.Questions.filter(a => !isNullOrWhitespace(a.Comment)).length; }
    get NotCommentedQuestionsCount(): number { return this.questionsCount - this.CommentedQuestionsCount; }
    get MostInconsistent(): PanelistSurveyQuestionReadModel[] 
    {
        if (this.rm.ConsistencyAnalysis == null) return null;
        return this.rm.Questions.filter(a => this.rm.ConsistencyAnalysis.MostInconsistentIds.includes(a.Id));
    }

    //@Watch('IsSaved')
    onIsSavedChanged(val: boolean, oldVal: boolean) 
    {
        if (val === false)
        {
            if (this.AutoSaveHandle == null)
            {
                this.AutoSaveHandle = setInterval(() =>
                {
                    if (this.IsSaved === false)
                    {
                        this.handleSavePanelistVotesCommand();
                    }

                }, 10000);
            }
        }
        else
        {
            if (this.AutoSaveHandle != null)
            {
                clearInterval(this.AutoSaveHandle);
                this.AutoSaveHandle = null;
            }
        }
    }


    ShowAlternativeDetailsCommand(name: string, desc: string)
    {
        this.alternativeDetailsDialog.show(name, desc);
    }

    ShowDetailsCommand()
    {
        this.criterionDetailsDialog.show(this.criterionName, this.rm.CriterionPath, this.rm.CriterionDescription);
    }


    scrollTop()
    {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }


    loadConsistencyAnalysis()
    {
        this.rm.ConsistencyAnalysis = null;

        if (this.IsSaved === false)
        {
            this.handleSavePanelistVotesCommand();
        }

        //this.runPanelistSurveyCriterionConsistencyAnalysisQueryV1(this.workspaceId, this.rm.CriteriaHierarchyId, this.rm.EvalModelId, this.surveyId, this.projectUserId, this.criterionId);
    }

    updateValue(q: PanelistSurveyQuestionReadModel, value: number | null)
    {
        if (q.Value !== value)
        {
            q.Value = value;
            this.IsSaved = false;
        }
    }

    updateComment(q: PanelistSurveyQuestionReadModel, comment: string)
    {
        if (q.Comment !== comment)
        {
            q.Comment = comment;
            this.IsSaved = false;
        }
    }


    handleSavePanelistVotesCommand()
    {
        this.IsSaved = null;

        const votes = this.rm.Questions.map(q =>
        {
            return {
                QuestionId: q.Id,
                Value: q.Value,
                Comment: q.Comment
            }
        });

        this.invokeSavePanelistVotesCommandV1(this.workspaceId, this.rm.EvalModelId, this.surveyId, this.projectUserId, votes, this.criterionId.toString());
    }


    mounted()
    {
        this.runPanelistSurveyCriterionPageQueryV1(this.workspaceId, this.surveyId, this.projectUserId, this.criterionId);
    }

    onSetModel(model: any, modelName: string) 
    {
        if (modelName == "PanelistSurveyCriterionPageReadModel")
        {
            this.rm = model as PanelistSurveyCriterionPageReadModel;
            this.initialized = true;
        }
        else if (modelName == "PanelistSurveyCriterionConsistencyAnalysisReadModel")
        {
            this.rm.ConsistencyAnalysis = model as PanelistSurveyCriterionConsistencyAnalysisReadModel;
        }
    }

    onCommandSucceed(cmd: IEvaluationCommand, correlationId: string, result: any)
    {
        if (SavePanelistVotesCommandV1.matchType(cmd))
        {
            if (this.criterionId === Number.parseInt(correlationId))
            {
                if (this.IsSaved == null)
                {
                    this.IsSaved = true;
                }
            }
        }
    }


    EnsureSavedOnExit(event: BeforeUnloadEvent)
    {
        if (this.IsSaved === true)
        {
            return;
        }

        this.handleSavePanelistVotesCommand();
        event.preventDefault();
        event.returnValue = "";
    }

    beforeMount()
    {
        window.addEventListener("beforeunload", this.EnsureSavedOnExit);
    }

    beforeRouteLeave(to: Route, from: Route, next: (arg?: any) => void)
    {
        if (this.IsSaved === false)
        {
            this.handleSavePanelistVotesCommand();
        }

        next();
    }

    beforeRouteUpdate(to: Route, from: Route, next: (arg?: any) => void)
    {
        if (this.IsSaved === false)
        {
            this.handleSavePanelistVotesCommand();
        }

        next();
    }

    beforeDestroy()
    {
        window.removeEventListener("beforeunload", this.EnsureSavedOnExit);

        if (this.AutoSaveHandle != null)
        {
            clearInterval(this.AutoSaveHandle);
            this.AutoSaveHandle = null;
        }
    }
}